"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTextureUrl = void 0;
const TEXTURES = {
    none: "",
    distressed: "Distressed.jpg",
    lights: "Lights.jpg",
    watercolor: "Watercolor.jpg",
    waves: "Waves.jpg",
    paper: "Paper.jpg",
    water: "Water.jpg",
    geometric: "Geometric.jpg",
};
const getUrl = (file) => new URL(`setfan/assets/${file}`, (process.env.REACT_APP_ASSETS_PATH ||
    process.env.ASSETS_URL_BASE ||
    "").replace(/([^\/])$/, "$1/")).toString();
/**
 * Get a fully qualified texture URL.  If the appropriate env variable cannot
 * be found this call with throw an exception.
 */
const getTextureUrl = (texture) => texture === "none" ? TEXTURES[texture] : getUrl(TEXTURES[texture]);
exports.getTextureUrl = getTextureUrl;
//# sourceMappingURL=textures.js.map